// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.c-header__menu-item.is-parent > a').forEach(link => {
//     link.addEventListener('click', (e) => {
//       e.preventDefault(); // parent link pe click se redirect na ho
//       const submenu = link.parentElement.querySelector('.c-header__submenu');
//       if (!submenu) return;
//       submenu.classList.toggle('d-none');
//     });
//   });
// });

// document.addEventListener('DOMContentLoaded', () => {

//   const header = document.querySelector('.c-header');
//   const links  = document.querySelectorAll('.c-header__menu-item.is-parent > a');

//   links.forEach(link => {
//     link.addEventListener('click', e => {
//       e.preventDefault();
//       e.stopPropagation();

//       link.parentElement
//         .querySelector('.c-header__submenu')
//         ?.classList.toggle('d-none');
//     });
//   });

//   // outside header click → close
//   document.addEventListener('click', () => {
//     header
//       .querySelectorAll('.c-header__submenu')
//       .forEach(menu => menu.classList.add('d-none'));
//   });

// });


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.c-header__menu-item.is-parent').forEach(item => {
    const submenu = item.querySelector('.c-header__submenu');

    item.addEventListener('mouseenter', () => {
      submenu.classList.remove('d-none');
    });

    item.addEventListener('mouseleave', () => {
      submenu.classList.add('d-none');
    });
  });
});



document.addEventListener('DOMContentLoaded', () => {
  var header = document.querySelector('.c-header');
  // console.log("header", header);
  var toggle = header.querySelector("[data-header-toggle]");
  var drawer = header.querySelector(".c-header__drawer");

  const closeDrawer = () => {
    drawer.hidden = true;
    toggle.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("c-header--no-scroll");
  };
  const modal = document.querySelector('[data-booking-modal]');
  const openButtons = document.querySelectorAll('[data-booking-open]');
  const bookButton = document.querySelector('.c-header__cta-btn');
  const bookButtonTwo = document.querySelector('.c-header__drawer-cta');
  const bookWidget = document.querySelector('#bookingWidget');
  const menuDrawer = document.querySelector('.c-header__drawer');

  if (!modal || !openButtons.length) return;

  const closeButton = modal.querySelector('[data-booking-close]');
  const backdrop = modal.querySelector('[data-booking-backdrop]');
  const focusTarget = closeButton || modal;

  let lastTrigger = null;
  const openModal = (event) => {
    event?.preventDefault();
    lastTrigger = event?.currentTarget || document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('booking-modal-open');
    focusTarget.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('booking-modal-open');
    lastTrigger?.focus();
  };

  openButtons.forEach((button) => button.addEventListener('click', openModal));
  bookButton?.addEventListener('click', openModal);
  bookWidget?.addEventListener('click', openModal);
  bookButtonTwo?.addEventListener('click', (event) => {
    openModal();
    closeDrawer();
  });
  closeButton?.addEventListener('click', closeModal);
  backdrop?.addEventListener('click', closeModal);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
  if (modal.querySelector('[data-appointment-status]')) openModal();
});
